import Modal from "./Modal";

import useBrowser from "../../hooks/useBrowser";
import useLocalization from "../../hooks/useLocalization";

import SkuMatrixEditor from "../editors/SkuMatrixEditor";

const SkuMatrixModal = ({ surveyId, skuMatrix, open, onClose, onSave }) => {
  const { windowWidth } = useBrowser();
  const { getTitle } = useLocalization();

  return (
    <Modal
      title={getTitle("skuMatrix")}
      open={open}
      onClose={onClose}
      width="100%"
      height="100%"
    >
      <SkuMatrixEditor
        skuMatrix={skuMatrix}
        surveyId={surveyId}
        onSave={onSave}
      />
    </Modal>
  );
};

export default SkuMatrixModal;
